import { render, staticRenderFns } from "./customSpinner.vue?vue&type=template&id=17a116c6&scoped=true&"
import script from "./customSpinner.vue?vue&type=script&lang=js&"
export * from "./customSpinner.vue?vue&type=script&lang=js&"
import style0 from "./customSpinner.vue?vue&type=style&index=0&id=17a116c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a116c6",
  null
  
)

export default component.exports